// Cliente del panel contra la misma API. No lleva el encabezado del negocio: el panel no trabaja dentro de una
// cuenta, y las rutas /api/panel resuelven en el servidor que quien llama es del equipo Glubi.
import { supabase } from './supabase';

export const API = import.meta.env.VITE_API_URL ?? 'http://127.0.0.1:8787';
// Los modelos de Glubi se configuran en el gateway: es el único servicio que tiene la llave para cifrar sus claves.
export const GATEWAY = conEsquema(import.meta.env.VITE_GATEWAY_URL ?? 'http://127.0.0.1:8788');

// Un dominio sin esquema («gateway-staging….railway.app», como lo da RAILWAY_PUBLIC_DOMAIN) el navegador lo toma
// como una ruta del propio panel, y la respuesta llega como el index.html del panel. Le pasó a staging.
function conEsquema(url: string): string {
  const limpia = url.trim().replace(/\/+$/, '');
  return /^https?:\/\//.test(limpia) ? limpia : `https://${limpia}`;
}

export class ErrorApi extends Error {
  constructor(message: string, readonly estado: number, readonly detalles: string[] = []) { super(message); }
}

type Opciones = { metodo?: 'GET' | 'POST'; cuerpo?: unknown };

export const api = <T = any>(ruta: string, opciones: Opciones = {}) => pedir<T>(API, ruta, opciones);
export const apiGateway = <T = any>(ruta: string, opciones: Opciones = {}) => pedir<T>(GATEWAY, ruta, opciones);

async function pedir<T>(base: string, ruta: string, opciones: Opciones): Promise<T> {
  const { data } = await supabase.auth.getSession();
  const r = await fetch(`${base}${ruta}`, {
    method: opciones.metodo ?? (opciones.cuerpo !== undefined ? 'POST' : 'GET'),
    headers: {
      ...(data.session ? { authorization: `Bearer ${data.session.access_token}` } : {}),
      ...(opciones.cuerpo !== undefined ? { 'content-type': 'application/json' } : {}),
    },
    body: opciones.cuerpo !== undefined ? JSON.stringify(opciones.cuerpo) : undefined,
  });
  const texto = await r.text();
  const cuerpo = texto ? JSON.parse(texto) : null;
  if (!r.ok) throw new ErrorApi(cuerpo?.error ?? `Error ${r.status}`, r.status, cuerpo?.detalles ?? []);
  return cuerpo as T;
}

export function mensajeDeError(e: unknown): string {
  if (e instanceof ErrorApi) return [e.message, ...e.detalles].join(' · ');
  return e instanceof Error ? e.message : 'Algo falló';
}
